/* This component CREATES a Pilot - Cohort - Source table for the pilotcohortsource collection in MongoDB. */

import React, { useState }                      from 'react'
import axios                                    from 'axios'
import {
   Box,
   Button,
   Grid,
   TextField,
   Typography }                                 from '@material-ui/core'
import InfoComponent                            from './InfoComponent'
import { node_server }                          from '../Helpers'
import PilotCohortSourceInputComponent          from './PilotCohortSourceInputComponent'
import PilotCohortSourceReadComponent           from './PilotCohortSourceReadComponent'

const PilotCohortSourceCreateComponent = () => {

   const [ id,                                  setId                            ]  =  useState('')
   const [ cohort,                              setCohort                        ]  =  useState('')
   const [ columnOneWidth,                      setColumnOneWidth                ]  =  useState('')
   const [ columnTwoWidth,                      setColumnTwoWidth                ]  =  useState('')
   const [ columnThreeWidth,                    setColumnThreeWidth              ]  =  useState('')
   const [ pilotName,                           setPilotName                     ]  =  useState('')
   const [ showInfoComponent,                   setShowInfoComponent             ]  =  useState(true)
   const [ source,                              setSource                        ]  =  useState('')
   const [ title,                               setTitle                         ]  =  useState('')
   const [ triggerUseEffect,                    setTriggerUseEffect              ]  =  useState(0)

   const info = [
      'So far we have been using 33% for each column width.',
   ]

   const closeComponent = () => {
      setShowInfoComponent(false)
   }

   const changeColumnOneWidth = (e) => {
      setColumnOneWidth(e.target.value)
      setShowInfoComponent(false)
   }

   const changeColumnTwoWidth = (e) => {
      setColumnTwoWidth(e.target.value)
   }

   const changeColumnThreeWidth = (e) => {
      setColumnThreeWidth(e.target.value)
   }

   const changeCohort = (e) => {
      setCohort(e.target.value)
   }

   const changePilotName = (e) => {
      setPilotName(e.target.value)
   }

   const changeSource = (e) => {
      setSource(e.target.value)
   }

   const changeTitle = (e) => {
      setTitle(e.target.value)
   }

   /* Fake method to satisfy PropTypes in a child component */
   const handleClick = () => {
      return null
   }

   const handleSubmit = () => {
      if (id === '') {
         axios.post(node_server + 'pilotCohortSourceTable', {
            columnOneWidth,
            columnTwoWidth,
            columnThreeWidth,
            cohort,
            pilotName,
            source,
            title
         })
            .then( res => res.data )
            .then( data => {
               setTriggerUseEffect(triggerUseEffect + 1)
               setCohort('')
               setPilotName('')
               setSource('')
               setId(data.pilotCohortSourceTableToDB._id)
            } )
            .catch( (error) => {
               console.error(error)
            } )
      }
      else {
         axios.put(node_server + 'pilotCohortSourceTable', {
            id,
            cohort,
            pilotName,
            source
         })
            .then( res => res.data )
            .then( data => {
               setTriggerUseEffect(triggerUseEffect + 1)
               setCohort('')
               setPilotName('')
               setSource('')
            } )
            .catch( (error) => {
               console.error(error)
            } )
      }
   }

   return (
      <Box>
         <Grid>
            <Grid>
               <Typography variant='h5' style={{ marginTop: '6rem', marginBottom: '1rem' }}>
                  Create a Pilot / Cohort / Source Table
               </Typography>
            </Grid>
            { showInfoComponent ? <InfoComponent closeComponent={closeComponent} info={info} /> : null }

            {id === ''
               ?
                  null
               :
                  /* triggerUseEffect is only used in this child component as a way to fire the useEffect each time
                     there is a POST or PUT so that the table can be viewed while it is being build by
                     PilotCohortSourceCreateComponent */
                  <PilotCohortSourceReadComponent handleClick={handleClick} id={id} triggerUseEffect={triggerUseEffect} />
            }

            {Number(columnOneWidth) > 9 && Number(columnTwoWidth) > 9 && Number(columnThreeWidth) > 9
               ?
                  <PilotCohortSourceInputComponent changeCohort={changeCohort} changePilotName={changePilotName} changeSource={changeSource} singleEntry={{}} />
               :
                  <Grid container direction='row' justifyContent='center' style={{marginTop: '1rem'}} >
                     <Grid item xs={12} style={{marginBottom: '1rem'}} >
                        <TextField name='pilot-cohort-source-table-title' label="Table Name (Class ...)" variant='outlined' style={{ width: '70%' }} onChange={changeTitle} value={title} autoFocus={true} />
                     </Grid>
                     <Grid item xs={3} >
                        <TextField name='pilot-cohort-source-table-column-one-width' label="Column One Width (%)" variant='outlined' style={{ width: '90%' }} onChange={changeColumnOneWidth} value={columnOneWidth} />
                     </Grid>
                     <Grid item xs={3} >
                        <TextField name='pilot-cohort-source-table-column-two-width' label="Column Two Width (%)" variant='outlined' style={{ width: '90%' }} onChange={changeColumnTwoWidth} value={columnTwoWidth} />
                     </Grid>
                     <Grid item xs={3} >
                        <TextField name='pilot-cohort-source-table-column-three-width' label="Column Three Width (%)" variant='outlined' style={{ width: '90%' }} onChange={changeColumnThreeWidth} value={columnThreeWidth} />
                     </Grid>
                  </Grid>
            }
         </Grid>
         {cohort === '' && pilotName === '' && source === ''
            ?
               <Grid item xs={2} style={{marginTop: '1rem'}} >
                  <Button data-testid='history-create-submit' variant='contained' color='primary' disabled >Submit</Button>
               </Grid>
            :
               <Grid item xs={2} style={{marginTop: '1rem'}} >
                  <Button data-testid='history-create-submit' variant='contained' color='primary' onClick={handleSubmit}>Submit</Button>
               </Grid>
         }
      </Box>
   )
}

export default PilotCohortSourceCreateComponent
